import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import Loading from 'components/Loading';
import Flex from 'ui/Flex/Flex';
import ActionButtonsGroup, { Action } from './ActionButtonsGroup';
import SwitchController from './SwitchController';

type PreVizFooterProps = {
    isNewTable: boolean;
    action: string;
    setAction: (arg1: Action) => void;
    isPrivate: boolean;
    isTableUpdateInProgress: boolean;
    setIsPrivate: (arg: boolean) => void;
    newTableName: string;
    cancel: () => void;
    onSubmit: () => void;
};
const PreVizFooter = ({
    isNewTable,
    action,
    setAction,
    isPrivate,
    isTableUpdateInProgress,
    setIsPrivate,
    newTableName,
    cancel,
    onSubmit,
}: PreVizFooterProps) => {
    const { t } = useTranslation();
    return (
        <Flex
            align="center"
            justify="space-between"
            sx={{ textAlign: 'center', m: '1rem' }}
        >
            {!isNewTable && (
                <ActionButtonsGroup action={action} setAction={setAction} />
            )}
            {isNewTable && (
                <SwitchController
                    name="share-import"
                    label={t('importCSV.rights.shareImport')}
                    checked={!isPrivate}
                    onChange={() => setIsPrivate(!isPrivate)}
                />
            )}
            <div style={{ display: 'flex' }}>
                <Button
                    onClick={cancel}
                    color="primary"
                    autoFocus
                    variant="outlined"
                    sx={{ mr: '1rem' }}
                >
                    {t('common.cancel')}
                </Button>
                {isTableUpdateInProgress ? (
                    <Loading small />
                ) : (
                    <Button
                        color="primary"
                        variant="contained"
                        disabled={isNewTable && newTableName === ''}
                        onClick={onSubmit}
                    >
                        {t('importCSV.import')}
                    </Button>
                )}
            </div>
        </Flex>
    );
};

export default React.memo(PreVizFooter);
